const audio = async (messageId: string): Promise<Blob> => {
  const response = await fetch(`/api/messages/${messageId}/audio`, {
    method: 'POST',
    credentials: 'include',
  })

  if (!response.ok) {
    throw new Error(`Audio fetch failed: ${response.status}`)
  }

  return response.blob()
}

export default { audio }
